import { render, staticRenderFns } from "./NavigationDrawerAssinatura.vue?vue&type=template&id=d06f9514&scoped=true&"
import script from "./NavigationDrawerAssinatura.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerAssinatura.vue?vue&type=script&lang=js&"
import style0 from "./NavigationDrawerAssinatura.vue?vue&type=style&index=0&id=d06f9514&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f9514",
  null
  
)

export default component.exports